<section class="dropdown main-nav-links box-block" vbDropdown dropdown>
		<button type="button" class="dropdown-toggle media-btn text-color-inherit" [attr.aria-label]="('Media' | translate) + '-' + ('UI_Menu' | translate)" [ngClass]="{'theme-header-txt util-no-underline util-uppercase': isTwoTierTheme}" dropdownToggle (click)="onToggleClick()">
			<span>{{ 'Media' | translate }}</span>
		</button>
		<media-menu *dropdownMenu id="media-dropdown" class="dropdown-menu" role="menu">
		</media-menu>
</section>
